import axios from 'axios';
import {API_URL} from './client';

const URL = `${API_URL}/reset-password/`;

const requestPasswordReset = async (email: string) => {
  const res = await axios.post(URL, {
    'email': email,
  });
  return res.data;
};

const actions = {
  requestPasswordReset,
};

export default actions;
